class TaskCategoryGroupPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'task_category_group.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'task_category_group._m';

    // Access archived task category group
    static ACCESS_ARCHIVE = 'task_category_group.access.archive';

    // Create new task category groups
    static CREATE = 'task_category_group.create';

    // Update task category group info
    static UPDATE = 'task_category_group.update';

    // Archive task category group
    static ARCHIVE = 'task_category_group.archive';

    // Restore archived task category group
    static RESTORE = 'task_category_group.restore';

    // Manage complexity settings of the task category group
    static COMPLEXITY_MANAGE = 'task_category_group.complexity_manage';
}

export default TaskCategoryGroupPermission;
